/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import dayjs from 'dayjs';

import * as fromGetClipsAction from 'app/library/store/actions/get-library-clips.action';
import { LibraryService } from 'app/library/services/library.service';
import { AssetsService } from 'app/shared/services/assets.service';

@Injectable()
export class GetLibraryClipsEffects {
  getLibraryClips$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGetClipsAction.GET_LIBRARY_CLIPS),
      switchMap((action: fromGetClipsAction.GetLibraryClips) => {
        return this.libraryService.getLibraryClips().pipe(
          map((assets) => {
            return assets.map((asset) => ({
              ...asset,
              event: asset.eventName ? { id: asset.eventId, name: asset.eventName } : null,
              game: asset.gameName ? { id: asset.gameId, name: asset.gameName } : null,
              owner: { id: asset.userId, firstName: asset.userFirstName, lastName: asset.userLastName },
              urlThumb: asset.urlThumb || this.assetsService.getUrlThumb(asset.url, asset.is60fps),
              uploadedAt:
                asset.metadata && asset.metadata.uploadedAt
                  ? dayjs(asset.metadata.uploadedAt).format('YYYY-MM-DD[T]HH:mm:ss.SSS')
                  : asset.createdAt,
            }));
          }),
          map((response) => {
            return new fromGetClipsAction.GetLibraryClipsSuccess(response);
          }),
          catchError((error) => of(new fromGetClipsAction.GetLibraryClipsFail(error.message)))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private libraryService: LibraryService,
    private assetsService: AssetsService
  ) {}
}
